module.exports = __webpack_public_path__ + "img/screen0.e669c4bc.png";